import FormFieldGroup from "./FormFieldGroup";
import PropTypes from "prop-types";
import Select from "react-select";
import { useState, useEffect, useRef } from "react";

function FormFieldDropdown(props) {
  const [val, setVal] = useState("noFirstFocus");
  let [hasError, setErrorState] = useState(false);
  let [firstFocus, setfirstFocus] = useState(false); //Only run validation on fields that have already been visited
  let [hasListener, sethasListener] = useState(false);
  const refInput = useRef(null);
  useEffect(() => {
    if (props.forceErrorCheck) {
      setfirstFocus(true);
    }
    checkErrors();
  }, [props.forceErrorCheck, firstFocus]);

  useEffect(() => {
    if (val === "noFirstFocus") {
      setVal(props.value);
    }
    (firstFocus || props.forceErrorCheck) && checkErrors();
  }, [val]);
  let options = props.options.reduce((pv, cv, index) => {
    return pv.concat({
      value: cv,
      label: cv,
    });
  }, []);
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // This line disables the blue border
      boxShadow: "none",
    }),
    valueContainer: (provided, state) => {
      const padding = "1px 8px";
      return { ...provided, padding };
    },
  };
  if (refInput.current && refInput.current.tagName === "INPUT") {
    if (!hasListener) {
      refInput.current.addEventListener("change", () => {
        setfirstFocus(true);
      });
      sethasListener(true);
    }
  }
  const onChangeLocal = (value) => {
    setVal(value);
    !firstFocus && setfirstFocus(true);
  };
  const checkErrors = () => {
    if (!props.isRequired) {
      return;
    }
    if (!val || (val === "" && firstFocus)) {
      setErrorState(true);
      props.onFieldError?.(props.name);
    }
    if (val && val !== "") {
      setErrorState(false);
      props.onFieldErrorCleared?.(props.name);
    }
  };
  return (
    <FormFieldGroup
      title={props.title}
      className={`dropdown ${hasError ? "has-error" : ""}`}
      errorElement={
        hasError && <span className="error">This field is required</span>
      }
    >
      <Select
        value={options.filter((option) => option.label === props.value)}
        options={options}
        styles={style}
        onChange={(value) => {
          props.onChange(props.name, value.value);
          onChangeLocal(value.value);
        }}
        defaultValue={options.filter(
          (option) => option.label === props.default
        )}
        // ref={ref =>{
        //     refInput.current = ref?.select.inputRef
        // }}
        onMenuClose={() => {
          setfirstFocus(true);
        }}
      />
    </FormFieldGroup>
  );
}

FormFieldDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  default: PropTypes.string,
  isRequired: PropTypes.bool,
  onFieldError: PropTypes.func,
  onFieldErrorCleared: PropTypes.func,
};

export default FormFieldDropdown;
